import _ from 'lodash';

const normalizeShoppingLinks = modelInfo => data => {
  if (data.ShoppingLinks) {
    return data.ShoppingLinks.reduce((res, curr) => ({ ...res, ...curr }));
  }

  const { year, carline, bodyStyle } = modelInfo;
  return _.get(data, [year, carline, bodyStyle], {});
};

export default normalizeShoppingLinks;
